const snakeToStartCase = (name?: string | null) =>
  (name ?? '')
    .split('_')
    .join(' ')
    .toLowerCase()
    .replace(/((^| )(.))/g, (letter: string) => letter.toUpperCase())

export default snakeToStartCase
